// Studio Screen A value types, ported from regulatory_cms/src/core/types.ts.
// The verdict enum and statement-value shape the studio's cards/chips expect;
// the adapter maps the main app's StatementGroup interface onto these.

// The verdict enum STAYS in FE code — the flow's logic (tiering, chips, matrix)
// needs the codes at compile time. But the CANONICAL verdict index lives in the
// backend central store (regulatory_content.VERDICT_INDEX) and, in step 3, will
// come from the CMS. These two MUST stay in sync: the backend test
// test_regulatory_content.py reads this literal and asserts equality with
// VERDICT_INDEX (the "store vocabulary vs FE enum" consistency check). Keep the
// order identical — it is the index.
export const VERDICTS = [
  "compliant",
  "compliant_with_conditions",
  "non_compliant",
  "pending",
  "unknown",
] as const
export type Verdict = (typeof VERDICTS)[number]

/** One disclosed exception behind a compliant_with_conditions verdict.
 *  Structurally identical to the main app's StatementCondition. */
export interface ConditionDisclosure {
  substance: string | null
  cas: string | null
  concentration: string | null
  location: string | null
  info: string | null
  gaps: string[]
}

export interface StatementValues {
  verdict: Verdict | null
  list_version: string | null
  scope_verbatim: string | null
  conditions?: ConditionDisclosure[]
}
